import {
  ambassadorsVuexStore,
  applicationsVuexStore,
  brandingAccountVuexStore,
  brandingAccountLoyaltyVuexStore,
  brandingAccountNavVuexStore,
  brandingAccountReferralVuexStore,
  brandingAccountRewardsVuexStore,
  brandingChallengeVuexStore,
  brandingGeneralVuexStore,
  brandingGiftingsVuexStore,
  brandingHeaderVuexStore,
  brandingProfilVuexStore,
  brandingReferralVuexStore,
  brandingReferralModalVuexStore,
  brandingRewardsVuexStore,
  brandingStepsVuexStore,
  brandingVipVuexStore,
  brandingVipLevelsVuexStore,
  brevoAccountVuexStore,
  campaignVuexStore,
  campaign_templatesVuexStore,
  challenge_creatorsVuexStore,
  challenge_templatesVuexStore,
  challengesVuexStore,
  claimsVuexStore,
  companyVuexStore,
  dashboardVuexStore,
  dashboardLoyaltyVuexStore,
  dashboardMissionsVuexStore,
  dashboardReferralVuexStore,
  dashboardRetentionVuexStore,
  fieldsVuexStore,
  gorgiasAccountVuexStore,
  hubspotAccountVuexStore,
  indexVuexStore,
  insiderAccountVuexStore,
  instagramsVuexStore,
  invoicesVuexStore,
  judgemeAccountVuexStore,
  klaviyoAccountVuexStore,
  localesVuexStore,
  loginVuexStore,
  loyaltyChallengeVuexStore,
  loyaltyCurrencyVuexStore,
  loyaltyOrdersVuexStore,
  loyaltySettingsVuexStore,
  mixpanelVuexStore,
  netReviewsAccountVuexStore,
  pageAccountVuexStore,
  pagesVuexStore,
  plansVuexStore,
  point_transactionsVuexStore,
  profilVuexStore,
  programsVuexStore,
  rechargeAccountVuexStore,
  recruitmentsVuexStore,
  referralProgramVuexStore,
  referralRewardVuexStore,
  referralsVuexStore,
  rewardsVuexStore,
  storesVuexStore,
  subscriptionsVuexStore,
  targetingsVuexStore,
  tiktoksVuexStore,
  tokywokyAccountVuexStore,
  typeformAccountVuexStore,
  utilsVuexStore,
  viptierLevelsVuexStore,
  viptierProgramsVuexStore,
  weglotAccountVuexStore,
  yotpoReviewAccountVuexStore,
  yotpoSmsBumpAccountVuexStore,
  helpersaccounthelperVuexStore 
} from "#imports"
const VuexStore = {
  ...indexVuexStore,
  modules: {
      'ambassadors': {
        ...ambassadorsVuexStore.default ?? ambassadorsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'applications': {
        ...applicationsVuexStore.default ?? applicationsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingAccount': {
        ...brandingAccountVuexStore.default ?? brandingAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingAccountLoyalty': {
        ...brandingAccountLoyaltyVuexStore.default ?? brandingAccountLoyaltyVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingAccountNav': {
        ...brandingAccountNavVuexStore.default ?? brandingAccountNavVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingAccountReferral': {
        ...brandingAccountReferralVuexStore.default ?? brandingAccountReferralVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingAccountRewards': {
        ...brandingAccountRewardsVuexStore.default ?? brandingAccountRewardsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingChallenge': {
        ...brandingChallengeVuexStore.default ?? brandingChallengeVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingGeneral': {
        ...brandingGeneralVuexStore.default ?? brandingGeneralVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingGiftings': {
        ...brandingGiftingsVuexStore.default ?? brandingGiftingsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingHeader': {
        ...brandingHeaderVuexStore.default ?? brandingHeaderVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingProfil': {
        ...brandingProfilVuexStore.default ?? brandingProfilVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingReferral': {
        ...brandingReferralVuexStore.default ?? brandingReferralVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingReferralModal': {
        ...brandingReferralModalVuexStore.default ?? brandingReferralModalVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingRewards': {
        ...brandingRewardsVuexStore.default ?? brandingRewardsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingSteps': {
        ...brandingStepsVuexStore.default ?? brandingStepsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingVip': {
        ...brandingVipVuexStore.default ?? brandingVipVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brandingVipLevels': {
        ...brandingVipLevelsVuexStore.default ?? brandingVipLevelsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'brevoAccount': {
        ...brevoAccountVuexStore.default ?? brevoAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'campaign': {
        ...campaignVuexStore.default ?? campaignVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'campaign_templates': {
        ...campaign_templatesVuexStore.default ?? campaign_templatesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'challenge_creators': {
        ...challenge_creatorsVuexStore.default ?? challenge_creatorsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'challenge_templates': {
        ...challenge_templatesVuexStore.default ?? challenge_templatesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'challenges': {
        ...challengesVuexStore.default ?? challengesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'claims': {
        ...claimsVuexStore.default ?? claimsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'company': {
        ...companyVuexStore.default ?? companyVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'dashboard': {
        ...dashboardVuexStore.default ?? dashboardVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'dashboardLoyalty': {
        ...dashboardLoyaltyVuexStore.default ?? dashboardLoyaltyVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'dashboardMissions': {
        ...dashboardMissionsVuexStore.default ?? dashboardMissionsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'dashboardReferral': {
        ...dashboardReferralVuexStore.default ?? dashboardReferralVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'dashboardRetention': {
        ...dashboardRetentionVuexStore.default ?? dashboardRetentionVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'fields': {
        ...fieldsVuexStore.default ?? fieldsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'gorgiasAccount': {
        ...gorgiasAccountVuexStore.default ?? gorgiasAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'hubspotAccount': {
        ...hubspotAccountVuexStore.default ?? hubspotAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'insiderAccount': {
        ...insiderAccountVuexStore.default ?? insiderAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'instagrams': {
        ...instagramsVuexStore.default ?? instagramsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'invoices': {
        ...invoicesVuexStore.default ?? invoicesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'judgemeAccount': {
        ...judgemeAccountVuexStore.default ?? judgemeAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'klaviyoAccount': {
        ...klaviyoAccountVuexStore.default ?? klaviyoAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'locales': {
        ...localesVuexStore.default ?? localesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'login': {
        ...loginVuexStore.default ?? loginVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'loyaltyChallenge': {
        ...loyaltyChallengeVuexStore.default ?? loyaltyChallengeVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'loyaltyCurrency': {
        ...loyaltyCurrencyVuexStore.default ?? loyaltyCurrencyVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'loyaltyOrders': {
        ...loyaltyOrdersVuexStore.default ?? loyaltyOrdersVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'loyaltySettings': {
        ...loyaltySettingsVuexStore.default ?? loyaltySettingsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'mixpanel': {
        ...mixpanelVuexStore.default ?? mixpanelVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'netReviewsAccount': {
        ...netReviewsAccountVuexStore.default ?? netReviewsAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'pageAccount': {
        ...pageAccountVuexStore.default ?? pageAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'pages': {
        ...pagesVuexStore.default ?? pagesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'plans': {
        ...plansVuexStore.default ?? plansVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'point_transactions': {
        ...point_transactionsVuexStore.default ?? point_transactionsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'profil': {
        ...profilVuexStore.default ?? profilVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'programs': {
        ...programsVuexStore.default ?? programsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'rechargeAccount': {
        ...rechargeAccountVuexStore.default ?? rechargeAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'recruitments': {
        ...recruitmentsVuexStore.default ?? recruitmentsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'referralProgram': {
        ...referralProgramVuexStore.default ?? referralProgramVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'referralReward': {
        ...referralRewardVuexStore.default ?? referralRewardVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'referrals': {
        ...referralsVuexStore.default ?? referralsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'rewards': {
        ...rewardsVuexStore.default ?? rewardsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'stores': {
        ...storesVuexStore.default ?? storesVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'subscriptions': {
        ...subscriptionsVuexStore.default ?? subscriptionsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'targetings': {
        ...targetingsVuexStore.default ?? targetingsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'tiktoks': {
        ...tiktoksVuexStore.default ?? tiktoksVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'tokywokyAccount': {
        ...tokywokyAccountVuexStore.default ?? tokywokyAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'typeformAccount': {
        ...typeformAccountVuexStore.default ?? typeformAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'utils': {
        ...utilsVuexStore.default ?? utilsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'viptierLevels': {
        ...viptierLevelsVuexStore.default ?? viptierLevelsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'viptierPrograms': {
        ...viptierProgramsVuexStore.default ?? viptierProgramsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'weglotAccount': {
        ...weglotAccountVuexStore.default ?? weglotAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'yotpoReviewAccount': {
        ...yotpoReviewAccountVuexStore.default ?? yotpoReviewAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'yotpoSmsBumpAccount': {
        ...yotpoSmsBumpAccountVuexStore.default ?? yotpoSmsBumpAccountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'helpers': {
        
        namespaced: true,
        modules: {
      'account-helper': {
        ...helpersaccounthelperVuexStore.default ?? helpersaccounthelperVuexStore,
        namespaced: true,
        modules: {},
      }
    },
      }
    }, 
  }
export default VuexStore